export const pastelPalette = [
  'var(--green-500)',
  'var(--pink-500)',
  'var(--cyan-500)',
  'var(--teal-500)',
  'var(--yellow-500)',
  'var(--indigo-500)',
  'var(--orange-500)',
];

export const brightPalette = [
  'rgba(255, 206, 86)',
  'rgba(75, 192, 192)',
  'rgba(153, 102, 255)',
  'rgba(255, 159, 64)',
];
